import { Injectable } from "@angular/core";
import { ReplaySubject } from "rxjs";
import { Router } from "@angular/router";
import { EncrptDecrptService } from "./encrpt-decrpt.service";

@Injectable({
    providedIn: "root"
})

export class GenerateRouteService {


    constructor(private route: Router,
        private encript: EncrptDecrptService) {

    }

    public queueCount = new ReplaySubject<any>(0);

    /** queue count */

    setQueueCount(property: any, storeProp: boolean = false) {
        if (storeProp) {
            localStorage.setItem('queueCount', JSON.stringify(property));
        }
        this.queueCount.next(property);
    }

    getQueueCount() {
        return this.queueCount;
    }

    // generateRoutePath(portalName, page, idObj) {
    //     let splitPath = page.split('_');
    //     let givenPathName = splitPath.pop();
    //     let givenModule = splitPath.join('-');
    //     let getPortalModules = routeModules[portalName];
    //     let { actualModule, path } = this.filterByModule(getPortalModules, givenModule);
    //     let pathName = this.filterByPath(path, givenPathName, idObj);
    //     portalName = portalName == 'teacher' ? '/' + portalName : portalName;
    //     return `${portalName}/${actualModule}/${pathName}`;
    // }

    // filterByModule(getPortalModules, moduleName) {
    //     return getPortalModules.find(el => el.givenModule == moduleName);
    // }

    // filterByPath(getPath, pathName, idObj) {
    //     let filteredPath = getPath.find(el => el.givenPath == pathName);
    //     return this.filterQueryParams(filteredPath, idObj);
    // }

    // filterQueryParams(params, idObj) {
    //     let pathQuery;
    //     if (params.isMultipleIdRequired == true) {
    //         let length = params.givenMulipleIds.length;
    //         if (length > 1) {
    //             pathQuery = params.givenMulipleIds.reduce((prev, curr) => String(idObj[prev]) + '/' + String(idObj[curr]))
    //         } else {
    //             pathQuery = idObj[params.givenMulipleIds[0]];
    //         }
    //     } else if (params.isSingleIdRequired == true) {
    //         pathQuery = params.actualPath + '/' + idObj[params.givensingleIdName];
    //     } else {
    //         pathQuery = params.actualPath;
    //     }
    //     return pathQuery; 
    // }

    // navigateRouteForPhysio(portalName, page, idObj) {
    //     this.route.navigate([`/physiotherapist/info/list`])
    // }

    // navigateRouteForDietitian(portalName, page, idObj) {
    //     this.route.navigate([`/dietitian/info/list`])
    // }

    // navigateRouteForGym(portalName, page, idObj) {
    //     if (page == 'member_list') {
    //         this.route.navigate(["/members/list"])
    //     } else if (page == 'dietician_consult') {
    //         this.route.navigate(["/consultation/dietitian-list"])
    //     } else if (page == 'physio_consult') {
    //         this.route.navigate(["consultation/list"]);
    //     } else if (page == 'diet_consult') {
    //         this.route.navigate(["/consultation/dietitian-list"])
    //     }
    // }


    navigateRouteForAdmin(portalName, page, idObj) {
        if (page == 'Booking') {
            let obj = {
                booking_id: idObj?.booking_id,
            };
            let encode = this.encript.encript(JSON.stringify(obj));
            this.route.navigate(["/bookings/view-booking"], { queryParams: { id: encode } });
        } else if (page == 'Artist') {
            let obj = {
                artist_id: idObj?.artist_id
            };
            let encode = this.encript.encript(JSON.stringify(obj))
            this.route.navigate(["/artists/view"], { queryParams: { id: encode } });
        } else if (page == 'Event') {
            let obj = {
                event_id: idObj?.event_id
            };
            let encode = this.encript.encript(JSON.stringify(obj))
            this.route.navigate(["/events/view"], { queryParams: { id: encode } });
        }
        else if (page == 'Place') {
            let obj = {
                place_Id:idObj?.place_id
            }
            let encode = this.encript.encript(JSON.stringify(obj))
            this.route.navigate(["/places/view"], { queryParams: { id: encode } });
        } else if (page == 'Ratings') {
            let obj = {
                rating_id: idObj?.rating_id,
            };
            let encode = this.encript.encript(JSON.stringify(obj));
            this.route.navigate(["/ratings-reviews/view"], { queryParams: { id: encode } });
        }
        else if (page == 'Mobile Register') {
            let obj = {
                customer_id: idObj?.customer_id,
            };
            let encode = this.encript.encript(JSON.stringify(obj));
            this.route.navigate(["/customers/view"], { queryParams: { id: encode } });
        } else {
            this.route.navigate(["/notification"]);
        }
    }
    
    navigateRouteForVenueOwner(portalName, page, idObj) {
        if (page == 'Booking') {
            let obj = {
                booking_id: idObj?.booking_id,
            };
            let encode = this.encript.encript(JSON.stringify(obj));
            this.route.navigate(["venue-owner/bookings/view-booking"], { queryParams: { id: encode } });
        } else if (page == 'Event') {
            let obj = {
                event_id: idObj?.event_id
            };
            let encode = this.encript.encript(JSON.stringify(obj))
            this.route.navigate(["venue-owner/events/view"], { queryParams: { id: encode } });
        } else {
            this.route.navigate(["venue-owner/venue-notification"]);
        }
    }

    array = { "key": "id", "value": "[2]", "description": "" }
}